import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import type { ModelsNeededForFirstEdit } from "cc-frontend/services/lesson-editor";
import type LessonEditor from "cc-frontend/services/lesson-editor"

@tagName("")
export default class FilterClasses extends Component {
  // args
  toggleClass!: (courseId: string) => void
  closeMenu!: Function
  editCourseTitleAndOrder!: Function
  showTemplateChooser!: Function
  courseId!: string
  modelsNeededForFirstEdit!: ModelsNeededForFirstEdit

  @service lessonEditor!: LessonEditor

  @action
  editCourse() {
    this.editCourseTitleAndOrder(this.courseId)
    this.closeMenu()
  }

  @action
  createTemplate() {
    this.showTemplateChooser()
    this.closeMenu()
  }

  @action
  createBlankLesson() {
    this.lessonEditor.createBlankLesson(this.modelsNeededForFirstEdit)
    this.closeMenu()
  }
}
